//@ts-nocheck

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { PulseAnimation, ShakeAnimation, ZoomAnimation } from "../animation";
export function getIconAnimation(animation, config) {
  switch (animation) {
    case 'zoom':
      return new ZoomAnimation(config);

    case 'pulse':
      return new PulseAnimation(config);

    case 'shake':
      return new ShakeAnimation(config);

    default:
      return null;
  }
}